<template>
  <div :class="$style.root">
    <LayoutSingleTypeHeadingComponent
      :pageData="pageData"
      routeName="about"
    />

    <CoreBlocksComponent
      v-if="blocks?.length"
      :blocks="blocks"
    />

    <a
      href="mailto:woonhuis@de-ateliers.nl"
      :class="$style.linkToEmail"
    >
      <div :class="$style.label">
        woonhuis@de-ateliers.nl
      </div>

      <SvgoEnvelop :class="$style.svg" />
    </a>
  </div>
</template>

<script setup>

const nuxtApp = useNuxtApp()
const routeName = computed(() => {
  return nuxtApp.$getRouteBaseName()
})

const props = defineProps({
  pageData: Object
})

const localizedData = computed(() => {
  return i18nGetLocalizedData(baseStrapiGetAttributes(props?.pageData))
})

const blocks = computed(() => {
  return localizedData?.value?.blocks
})
</script>

<style module>
.root {
  display: grid;
  grid-row-gap: var(--unit--vertical--sextuple);
}

.linkToEmail {
  composes: reset-link from global;

  position: relative;

  max-height: var(--100svh);
  aspect-ratio: 16 / 9;
  width: 100%;

  padding: var(--unit--vertical--tripple) var(--unit--horizontal--double);
  background-color: var(--color--pink--light);
}

.linkToEmail .label {
  position: absolute;
  top: var(--unit--vertical--double);
  left: var(--unit--horizontal);
  right: var(--unit--horizontal);
  text-align: center;
}

.linkToEmail:hover .label {
  color: var(--color--accent);
}

.svg {
  overflow: visible;

  stroke: var(--color--primary);
  overflow: visible;
  stroke-width: var(--stroke--thick);
  stroke-linecap: round;

  width: 100%;
  height: 100%;
}


.linkToEmail:hover .svg {
  stroke: var(--color--accent);
}

</style>
